var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_724_5311"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_724_5311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.000080078125,15.000000411987305C12.000080078125,15.000000411987305,7.757080078125,10.757000411987304,7.757080078125,10.757000411987304C7.757080078125,10.757000411987304,9.172080078125,9.343000411987305,9.172080078125,9.343000411987305C9.172080078125,9.343000411987305,12.000080078125,12.172000411987305,12.000080078125,12.172000411987305C12.000080078125,12.172000411987305,14.828080078125,9.343000411987305,14.828080078125,9.343000411987305C14.828080078125,9.343000411987305,16.243080078125,10.757000411987304,16.243080078125,10.757000411987304C16.243080078125,10.757000411987304,12.000080078125,15.000000411987305,12.000080078125,15.000000411987305C12.000080078125,15.000000411987305,12.000080078125,15.000000411987305,12.000080078125,15.000000411987305Z",
    fill: "#8E94A9",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.9f951aa8e5f381ce47b84eb121a89b28.svg";
export { ForwardRef as ReactComponent };